import type { ReactNode } from 'react';
import { createContext, useEffect, useState } from 'react';

import type { CurrentAmplifyUser } from '../api/ampUser';
import { getCurrentAmplifyUser } from '../api/ampUser';

interface AmplifyUserContextValue {
  user: CurrentAmplifyUser | null;
  isLoading: boolean;
  error: Error | null;
}

export const AmplifyUserContext = createContext<
  AmplifyUserContextValue | undefined
>(undefined);

AmplifyUserContext.displayName = 'AmplifyUserContext';

export const AmplifyUserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<CurrentAmplifyUser | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getCurrentAmplifyUser();
        setUser(data);
        setError(null);
      } catch (err) {
        setError(err as Error);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <AmplifyUserContext.Provider value={{ user, isLoading, error }}>
      {children}
    </AmplifyUserContext.Provider>
  );
};

AmplifyUserProvider.displayName = 'AmplifyUserProvider';
